import React, {FC, useEffect, useState} from 'react'
import { OrganizationTable } from './components/OrganizationTable';
import axios from 'axios'
import { Auth } from 'aws-amplify';

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND
export const GET_ALL_ORGANIZATIONS_URL = `${API_URL_API}/organization`


const OrganizatoinListPage: FC = () => {

  const [loading, SetLoading] = useState(true);
  const [organizations, setOrganizations] = useState([]);


  useEffect(() => {
    getAllOrganizations()
  },[])


  const getAllOrganizations = async () => {
    
    try {

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      const {data: result} = await axios.get(GET_ALL_ORGANIZATIONS_URL,{
        headers : {
          Authorization: `Bearer ${token}`
        }
      });
        setOrganizations(result.data);
        SetLoading(false);
    } catch (err) {
      console.log(err)
    }     
  };

    return (
        <>
        {
          loading ? (
            <div className='d-flex flex-center'>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
              <span className="spinner-grow text-dark mx-2"></span>
            </div>
          ) : (
              
            <OrganizationTable orgns={organizations} getAllOrgns={getAllOrganizations} className='mb-5 mb-xl-8' />
          )
        }

          
        </>
  )
}

export {OrganizatoinListPage}
